import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';

// Portugal Continental
proj4.defs("EPSG:27493","+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=180.598 +y_0=-86.99 +ellps=intl +towgs84=-239.749,88.181,30.488,-0.263,-0.082,-1.211,2.229 +units=m +no_defs +type=crs");
proj4.defs("EPSG:3763", "+title=ETRS89 / Portugal TM06 +proj=tmerc +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
// Açores
proj4.defs("EPSG:32626","+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs");
proj4.defs("EPSG:3186","+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs");
proj4.defs("EPSG:5015","+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
proj4.defs("EPSG:5014","+proj=utm +zone=25 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
proj4.defs("EPSG:5016","+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
// Madeira
proj4.defs("EPSG:2191","+proj=utm +zone=28 +ellps=intl +units=m +no_defs");
proj4.defs("EPSG:3061","+proj=utm +zone=28 +ellps=intl +towgs84=-502.862,-247.438,312.724,0,0,0,0 +units=m +no_defs");
//WGS 84 / Cape Verde National
proj4.defs("EPSG:4826","+proj=lcc +lat_0=15.8333333333333 +lon_0=-24 +lat_1=15 +lat_2=16.6666666666667 +x_0=161587.83 +y_0=128511.202 +datum=WGS84 +units=m +no_defs +type=crs");

register(proj4);

export default {};